"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PcbFootprintSchema = void 0;
const zod_1 = require("zod");
const Footprint_1 = require("./Footprint");
const Pad_1 = require("./Pad");
exports.PcbFootprintSchema = Footprint_1.FootprintSchema.extend({
    pads: zod_1.z.lazy(() => Pad_1.PadSchema.array()),
});
//# sourceMappingURL=PcbFootprint.js.map